document.addEventListener("DOMContentLoaded", function() {
    let quickAddDrawer = document.querySelector('#CartDrawer')
    console.log(quickAddDrawer)
    if (quickAddDrawer) {
        let observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
                console.log('test')
                BSS_B2B.observer.cartSubject.listenCartCheckout() 
            });
        });
        observer.observe(quickAddDrawer, {
            childList: true,
            attributes: true
        });
    }
    setTimeout(() => {
  function handleButtonClick(e) {
    const button = e.currentTarget;
    const oldText = button.value;

    // Deshabilitar el botón y mostrar "Cargando..."
    button.style.pointerEvents = 'none';
    button.style.opacity = '0.6';
    button.value = 'Loading ...';

    // Redirigir al checkout después de 3 segundos
    setTimeout(() => {
      button.style.pointerEvents = 'unset';
      button.style.opacity = '1';
      button.value = oldText;

      // Redirige al checkout una vez que se haya hecho el "loading"
      window.location.href = '/checkout';
    }, 1000);
  }


  const observer = new MutationObserver(() => {
    const buttons = document.querySelectorAll('.proceed-to-checkout');
    buttons.forEach(button => {
      // Tránh gán nhiều lần
      if (!button.hasAttribute('bss-click-bound')) {
        button.addEventListener('click', handleButtonClick);
        button.addEventListener('dblclick', handleButtonClick);
        button.setAttribute('bss-click-bound', 'true');
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  const buttons = document.querySelectorAll('.proceed-to-checkout');
  buttons.forEach(button => {
    if (!button.hasAttribute('bss-click-bound')) {
      button.addEventListener('click', handleButtonClick);
      button.addEventListener('dblclick', handleButtonClick);
      button.setAttribute('bss-click-bound', 'true');
    }
  });
}, 500);
});



document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname === '/') {
    let a = document.querySelectorAll('[bss-b2b-product-id]')
    if (a.length) {
      a.forEach(element => {
       element.removeAttribute('bss-b2b-product-id')
      element.removeAttribute('bss-b2b-variant-price')
       element.removeAttribute('bss-b2b-product-price')
        element.removeAttribute('bss-b2b-variant-id')
         element.removeAttribute('bss-b2b-featured-product')
      });
    }
  }
});


